import { createFileRoute } from '@tanstack/react-router'
import { useOrganization } from '@/pages/organizations/detail'
import { usePlan } from '@/pages/organizations/detail/plan'
import { useSelector } from 'react-redux'
import Plan from '@/features/plans/components/Plan'

export const Route = createFileRoute('/app/organizations/$organizationId/plan/items/$itemId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { itemId } = Route.useParams()
  const { organization } = useOrganization()
  const {
    userCanViewActionPlan,
    userCanEditActionPlan,
    userCanViewAssessments,
    userCanEditAssessments,
    userCanViewCriterionTasks,
    userCanViewCriterionNotes,
    userCanViewTeam,
  } = usePlan()
  const currentUser = useSelector((state: any) => state.auth.currentUser)

  return (
    <Plan
      detailItemId={itemId}
      currentUser={currentUser}
      organization={organization}
      userCanViewActionPlan={userCanViewActionPlan}
      userCanEditActionPlan={userCanEditActionPlan}
      userCanViewAssessments={userCanViewAssessments}
      userCanEditAssessments={userCanEditAssessments}
      userCanViewCriterionTasks={userCanViewCriterionTasks}
      userCanViewCriterionNotes={userCanViewCriterionNotes}
      userCanViewTeam={userCanViewTeam}
    />
  )
}
